import { render } from "./supportCard.vue?vue&type=template&id=7777e1c3&scoped=true&ts=true"
import script from "./supportCard.vue?vue&type=script&lang=ts"
export * from "./supportCard.vue?vue&type=script&lang=ts"

import "./supportCard.vue?vue&type=style&index=0&id=7777e1c3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7777e1c3"]])

export default __exports__